const GIF_BASE_URL = 'https://erin-images.s3.us-east-2.amazonaws.com/gifs';

// Curated GIFs were originally Tenor IDs; the files now live in our own
// bucket keyed by that same ID, so company.gifIds keeps working unchanged.
const buildGifUrl = (id) => `${GIF_BASE_URL}/${id}.gif`;

const CustomGifPicker = ({ gifIds, onGifClick }) => {
  const ids = (Array.isArray(gifIds) ? gifIds : String(gifIds).split(','))
    .map((id) => String(id).trim())
    .filter(Boolean);
  const gifs = ids.map((id) => ({ id, imageUrl: buildGifUrl(id) }));

  return (
    <div style={{
      width: '100%',
      height: '300px',
      overflowY: 'auto',
      display: 'flex',
      flexDirection: 'row',
    }}>
      <div style={{
        display: 'flex',
        flexDirection: 'column',
        width: '50%',
        paddingRight: '2.5px',
      }}>
        {gifs.filter((_, index) => index % 2 === 0).map((gif) => (
          <GifItem key={gif.id} gif={gif} onClick={onGifClick} />
        ))}
      </div>
      <div style={{
        display: 'flex',
        flexDirection: 'column',
        width: '50%',
        paddingLeft: '2.5px',
      }}>
        {gifs.filter((_, index) => index % 2 !== 0).map((gif) => (
          <GifItem key={gif.id} gif={gif} onClick={onGifClick} />
        ))}
      </div>
    </div>
  );
};

const GifItem = ({ gif, onClick }) => (
  <div
    style={{
      width: '100%',
      marginBottom: '5px',
      cursor: 'pointer'
    }}
    onClick={() => onClick(gif)}
  >
    <img
      src={gif.imageUrl}
      alt=""
      style={{
        width: '100%',
        height: 'auto',
        display: 'block'
      }}
    />
  </div>
);

export default CustomGifPicker;
